/**
 * Neutralizes log-injection (CWE-117) vectors before values are written to the
 * logger/console. User-controlled data (urls, form values, error payloads) can
 * contain CR/LF or control characters that forge fake log entries or corrupt
 * log parsers. This collapses CR/LF into a single space and strips remaining
 * C0 control characters and DEL, leaving normal printable text intact.
 */
function sanitizeForLog(value) {
    const str = typeof value === 'string' ? value : String(value);
    // Collapse CR/LF first so injected line breaks cannot forge new log entries.
    const noNewlines = str.replace(/\r\n|\r|\n/g, ' ');
    // Strip remaining C0 control characters (0x00-0x1F) and DEL (0x7F).
    let out = '';
    for (let i = 0; i < noNewlines.length; i++) {
        const code = noNewlines.charCodeAt(i);
        if (code <= 0x1f || code === 0x7f) {
            continue;
        }
        out += noNewlines.charAt(i);
    }
    return out;
}

export default sanitizeForLog;
